module.exports = require('./helpers/bundle-url').getBundleURL('7YeuW') + "calendar-icon.51fc3721.png";